import { render } from "./ProductComp.vue?vue&type=template&id=0d7e4732&scoped=true"
import script from "./ProductComp.vue?vue&type=script&lang=js"
export * from "./ProductComp.vue?vue&type=script&lang=js"

import "./ProductComp.vue?vue&type=style&index=0&id=0d7e4732&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gigae\\projects\\ecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7e4732"]])

export default __exports__